import React, { PropsWithChildren } from 'react'
import Head from 'next/head'

export const Helmet = ({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element => (
  <Head>{children}</Head>
)
